import Base from './Base';

export default class ShopEmployee extends Base {
    constructor(props) {
        super();
        this.import(props);
    }

    import(props) {
        if (!props) {
            props = {};
        }

        if (typeof props === 'number') {
            this.id = props;
            return;
        }

        this.id = this.assign('id', props);
        this.shopId = this.assign('shopId', props);
        this.userId = this.assign('userId', props);
        this.contractHoursPerWeek = this.assign('contractHoursPerWeek', props) || 40;
        this.hourlyRate = this.assign('hourlyRate', props);
        this.color = this.assign('color', props) || '#4CAF50';
        this.active = props.active !== undefined ? props.active : true;
        this.startDate = this.assign('startDate', props);
        this.endDate = this.assign('endDate', props);
        
        // Nested objects
        this.shop = this.assign('shop', props);
        this.user = this.assign('user', props);
        
        this.createdAt = props.createdAt;
        this.updatedAt = props.updatedAt;
    }

    export() {
        return {
            id: this.id,
            shopId: this.shopId,
            userId: this.userId,
            contractHoursPerWeek: this.contractHoursPerWeek,
            hourlyRate: this.hourlyRate,
            color: this.color,
            active: this.active,
            startDate: this.startDate,
            endDate: this.endDate
        };
    }

    get displayName() {
        return this.user?.name || `Employee #${this.id}`;
    }
}
